import React, { useState, useEffect } from 'react';

export default function TextAnalyzer() {
  const [text, setText] = useState('');
  const [stats, setStats] = useState({
    characters: 0,
    charactersNoSpaces: 0,
    words: 0,
    sentences: 0,
    paragraphs: 0,
    readingTime: 0,
  });

  useEffect(() => {
    // 분석 수행
    const characters = text.length;
    const charactersNoSpaces = text.replace(/\s/g, '').length;
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;
    const sentences = text.trim() ? text.split(/[.!?]+/).filter(Boolean).length : 0;
    const paragraphs = text.trim() ? text.split(/\n+/).filter(Boolean).length : 0;
    
    // 평균 읽기 속도: 분당 225단어 (한국어 기준)
    const readingTime = words > 0 ? Math.max(1, Math.ceil(words / 225)) : 0;

    setStats({
      characters,
      charactersNoSpaces,
      words,
      sentences,
      paragraphs,
      readingTime,
    });
  }, [text]);

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">텍스트 분석기</h1>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          분석할 텍스트를 입력하세요
        </label>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="w-full h-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="여기에 텍스트를 입력하세요..."
        />
      </div>
      
      <div className="bg-white shadow overflow-hidden rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">분석 결과</h3>
          
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
            <div className="bg-gray-50 px-4 py-3 rounded-md">
              <dt className="text-sm font-medium text-gray-500">글자수</dt>
              <dd className="mt-1 text-xl font-semibold text-indigo-600">{stats.characters}</dd>
            </div>
            
            <div className="bg-gray-50 px-4 py-3 rounded-md">
              <dt className="text-sm font-medium text-gray-500">글자수 (공백 제외)</dt>
              <dd className="mt-1 text-xl font-semibold text-indigo-600">{stats.charactersNoSpaces}</dd>
            </div>
            
            <div className="bg-gray-50 px-4 py-3 rounded-md">
              <dt className="text-sm font-medium text-gray-500">단어수</dt>
              <dd className="mt-1 text-xl font-semibold text-indigo-600">{stats.words}</dd>
            </div>
            
            <div className="bg-gray-50 px-4 py-3 rounded-md">
              <dt className="text-sm font-medium text-gray-500">문장수</dt>
              <dd className="mt-1 text-xl font-semibold text-indigo-600">{stats.sentences}</dd>
            </div>
            
            <div className="bg-gray-50 px-4 py-3 rounded-md">
              <dt className="text-sm font-medium text-gray-500">문단수</dt>
              <dd className="mt-1 text-xl font-semibold text-indigo-600">{stats.paragraphs}</dd>
            </div>
            
            <div className="bg-gray-50 px-4 py-3 rounded-md">
              <dt className="text-sm font-medium text-gray-500">읽기 예상 시간</dt>
              <dd className="mt-1 text-xl font-semibold text-indigo-600">{stats.readingTime}분</dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 